//////////////////////////////////////////////////
// Samples Screen
//////////////////////////////////////////////////

import Lobby from './Lobby';
import OS from '../tablet/OS';
import IO from '../tablet/IO';
import MediaLib from '../tablet/MediaLib';
import ScratchAudio from '../utils/ScratchAudio';
import Localization from '../utils/Localization';
import {gn, newHTML} from '../utils/lib';

let frame;
// Should ScratchJr projects be saved when the sample project is changed?
// Enabled for the PBS version; disabled for the ScratchJr version
// window.Settings.useStoryStarters

export default class Samples {
    static init () {
        frame = gn('htmlcontents');
        gn('tabicon').ontouchstart = Samples.playHowTo;
        gn('tabicon').onclick = Samples.playHowTo;
        var div = newHTML('div', 'samples on', frame);
        div.setAttribute('id', 'samples');

        Samples.display('samples');
    }

    ////////////////////////////
    // Show Me How
    ////////////////////////////

    static playHowTo (e) {
        e.preventDefault();
        e.stopPropagation();
        ScratchAudio.sndFX('tap.wav');
        window.location.href = 'gettingstarted.html?place=help';
    }

    ////////////////////////////
    // Learn Samples
    ////////////////////////////

    static display (key) {
        var div = gn(key);
        // Clear any previous render to avoid duplicates/race effects
        try { while (div.firstChild) { div.removeChild(div.firstChild); } } catch (_) {}

        // Prefer DB-backed samples if already seeded
        try {
            if (window.dbModule && window.dbModule.projectCache && window.dbModule.projectCache.size > 0) {
                // Collect and sort deterministically by localized display name
                let dbSamples = Array.from(window.dbModule.projectCache.values()).filter(p => {
                    return (p && (p.gallery === 'samples' || (p.metadata && p.metadata.gallery === 'samples')));
                });
                if (dbSamples.length > 0) {
                    try {
                        dbSamples = dbSamples.map(p => {
                            const base = p.name || 'Sample';
                            const localized = Localization.localize('SAMPLE_' + base) || base;
                            return { rec: p, sortKey: String(localized).toLowerCase() };
                        }).sort((a, b) => (a.sortKey < b.sortKey ? -1 : (a.sortKey > b.sortKey ? 1 : 0))).map(x => x.rec);
                    } catch (_) { /* if localization fails, keep original order */ }
                    Samples.displayFromDB(div, dbSamples);
                    setTimeout(Samples.show, 10);
                    return;
                }
            }
        } catch (e) { /* ignore and fall back */ }

        // Fallback to legacy on-demand fetch via MediaLib
        var files = MediaLib[key];
        for (var i = 0; i < files.length; i++) {
            Samples.addLink(div, i, files[i]);
            Samples.requestFromServer(i, files[i], displayThumb);
        }
        function displayThumb (pos, str) {
            var mt = gn('sample-' + pos);
            var data = IO.parseProjectData(JSON.parse(str)[0]);
            var name = mt.childNodes[1];

            // Localize sample project names
            var sampleName = data.name;
            sampleName = Localization.localize('SAMPLE_' + sampleName);

            name.textContent = sampleName;
            var cnv = mt.childNodes[0].childNodes[1];
            Samples.insertThumbnail(cnv, data.thumbnail);
            mt.onclick = function (evt) {
                Samples.loadMe(evt, mt);
            };
        }
        setTimeout(Samples.show, 10);
    }

    // Render samples list from DB cache (window.dbModule.projectCache)
    static displayFromDB (parent, projects) {
        // Ensure clean container before appending
        try { while (parent.firstChild) { parent.removeChild(parent.firstChild); } } catch (_) {}

        for (let i = 0; i < projects.length; i++) {
            const p = projects[i];
            // Create tile
            var tb = newHTML('div', 'samplethumb', parent);
            tb.setAttribute('id', 'sample-' + i);
            tb.md5 = p.id; // Use project id directly for pmd5
            tb.type = 'samplethumb';

            var mt = newHTML('div', 'thumb pos' + (i % 8), tb);
            newHTML('div', 'woodframe', mt);
            var cnv = newHTML('div', 'sampleicon', mt);

            // Thumbnail: parse JSON string if needed
            try {
                let thumb = p.thumbnail;
                if (typeof thumb === 'string') { thumb = JSON.parse(thumb); }
                let md5 = (thumb && thumb.md5) ? thumb.md5 : null;
                if (!md5 && p.json) {
                    let j = (typeof p.json === 'string') ? JSON.parse(p.json) : p.json;
                    const pageKey = j.currentPage || (j.pages && j.pages[0]) || 'page 1';
                    md5 = j[pageKey] && j[pageKey].md5 ? j[pageKey].md5 : null;
                }
                if (md5) {
                    cnv.style.backgroundImage = 'url(\'' + md5 + '\')';
                }
            } catch (_) { /* ignore */ }

            var nameEl = newHTML('p', undefined, tb);
            try {
                const localized = Localization.localize('SAMPLE_' + (p.name || 'Sample'));
                nameEl.textContent = (localized && localized !== 'Sample' && !String(localized).startsWith('Sample ')) ? localized : (p.name || '');
            } catch (_) {
                nameEl.textContent = p.name || '';
            }

            // Avoid closure issues; capture tile reference per iteration
            const tile = tb;
            tile.onclick = function (evt) { Samples.loadMe(evt, tile); };
            tile.ontouchstart = function (evt) { Samples.loadMe(evt, tile); };
        }
    }

    static show () {
        Lobby.busy = false;
        frame.parentNode.scrollTop = 0;
        gn('samples').className = 'samples on';
    }

    static loadMe (e, mt) {
        e.preventDefault();
        e.stopPropagation();
        ScratchAudio.sndFX('tap.wav');
        OS.analyticsEvent('samples', 'sample_opened', mt.textContent);
        var md5 = mt.md5;
        var sampleId = (window.__SAMPLE_ID_MAP__ && md5) ? window.__SAMPLE_ID_MAP__[md5] : null;
        var pmd5 = sampleId || md5; // Prefer DB project id if seeded
        window.location.href = 'editor.html?pmd5=' + encodeURIComponent(pmd5) + '&mode='
            + ((window.Settings.useStoryStarters) ? 'storyStarter' : 'look');
    }

    static insertThumbnail (img, data) {
        var md5 = data.md5;
        if (md5) {
            img.style.backgroundImage = 'url(\'' + md5 + '\')';
        }
    }

    static addLink (parent, pos, md5) {
        var tb = newHTML('div', 'samplethumb', parent);
        tb.setAttribute('id', 'sample-' + pos);
        tb.md5 = md5;
        tb.type = 'samplethumb';
        var mt = newHTML('div', 'thumb pos' + pos, tb);
        newHTML('div', 'woodframe', mt);
        newHTML('div', 'sampleicon', mt);
        var name = newHTML('p', undefined, tb);
        // Microsoft UX: No fallback placeholder names to prevent flash
        name.textContent = '';
    }

    static requestFromServer (pos, url, whenDone) {
        var xmlrequest = new XMLHttpRequest();
        xmlrequest.addEventListener('error', transferFailed, false);
        xmlrequest.onreadystatechange = function () {
            if (xmlrequest.readyState == 4) {
                whenDone(pos, xmlrequest.responseText);
            }
        };
        xmlrequest.open('GET', url, true);
        xmlrequest.send(null);
        function transferFailed (e) {
            e.preventDefault();
            e.stopPropagation();
            // Failed loading
        }
    }
}
